import React, { useState, useEffect } from 'react';
import { surveyApiService } from '../../api/surveyApi';
import { useNavigate } from 'react-router-dom';
import {
    ChartBarIcon,
    ArrowTopRightOnSquareIcon,
    CheckCircleIcon,
    PauseCircleIcon,
} from '@heroicons/react/24/outline';
import DataTable from '../../components/ui/DataTable';
import TableAction, { TableActionGroup } from '../../components/ui/TableAction';

const SurveyGlobalAnalytics = () => {
    const [surveys, setSurveys] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSurveys = async () => {
            try {
                const data = await surveyApiService.getSurveys();
                setSurveys(Array.isArray(data) ? data : (data?.results || []));
            } catch (error) {
                console.error('Error fetching surveys:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchSurveys();
    }, []);

    const columns = [
        {
            header: 'ANKET BAŞLIĞI',
            accessorKey: 'title',
            size: 300,
            cell: ({ row }) => {
                const survey = row.original;
                return (
                    <div className="flex flex-col">
                        <span className="text-sm font-bold text-slate-900 dark:text-white leading-tight">
                            {survey.title?.tr || Object.values(survey.title || {})[0] || 'İsimsiz Anket'}
                        </span>
                        <span className="text-[10px] text-slate-400 font-medium tracking-tight">#{survey.slug}</span>
                    </div>
                );
            }
        },
        {
            header: 'DURUM',
            accessorKey: 'is_active',
            size: 120,
            cellClassName: 'text-center',
            cell: ({ getValue }) => {
                const isActive = getValue();
                return (
                    <div className="flex justify-center">
                        {isActive ? (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-emerald-50 dark:bg-emerald-500/10 text-[10px] font-bold text-emerald-600 dark:text-emerald-500 border border-emerald-100 dark:border-emerald-500/20">
                                <CheckCircleIcon className="w-3 h-3" />
                                AKTİF
                            </span>
                        ) : (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-slate-50 dark:bg-slate-800 text-[10px] font-bold text-slate-400 border border-slate-100 dark:border-slate-800">
                                <PauseCircleIcon className="w-3 h-3" />
                                PASİF
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            header: 'VERSİYON',
            accessorKey: 'version',
            size: 100,
            cellClassName: 'text-center',
            cell: ({ getValue }) => (
                <span className="text-[10px] font-bold text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded">
                    V{getValue() || 1}
                </span>
            )
        },
        {
            header: 'TOPLAM KATILIM',
            accessorKey: 'submission_count',
            size: 150,
            cellClassName: 'text-center',
            cell: ({ getValue }) => (
                <div className="flex flex-col items-center">
                    <span className="text-sm font-bold text-slate-900 dark:text-white">{getValue() || 0}</span>
                    <span className="text-[9px] text-slate-400 font-bold uppercase tracking-tighter">YANIT</span>
                </div>
            )
        },
        {
            header: 'SÜRE',
            accessorKey: 'estimated_minutes',
            size: 120,
            cellClassName: 'text-center',
            cell: ({ getValue }) => (
                <span className="text-xs font-bold text-slate-600 dark:text-slate-300">
                    {getValue() || 0} Dakika
                </span>
            )
        },
        {
            header: 'İŞLEMLER',
            id: 'actions',
            size: 80,
            cell: ({ row }) => (
                <TableActionGroup justify="end">
                    <TableAction
                        icon={ChartBarIcon}
                        onClick={() => navigate(`/survey/analytics/${row.original.slug}`)}
                        color="indigo"
                        title="Analizi Aç"
                    />
                </TableActionGroup>
            )
        }
    ];

    return (
        <div className="p-8 max-w-7xl mx-auto space-y-8">
            <div className="flex items-end justify-between border-b border-slate-200 dark:border-slate-800 pb-8">
                <div className="space-y-1">
                    <h1 className="text-3xl font-bold text-slate-900 dark:text-white tracking-tight">Global Raporlar</h1>
                    <p className="text-sm text-slate-500 font-medium tracking-tight uppercase tracking-widest text-[10px]">Tüm anketlerin metriklerini karşılaştırmalı olarak inceleyin</p>
                </div>
                <div className="flex items-center gap-2 text-xs font-bold text-slate-400 bg-slate-50 dark:bg-slate-800/50 px-3 py-1.5 rounded-lg border border-slate-100 dark:border-slate-800">
                    <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                    {surveys.length} ANKET ANALİZ EDİLİYOR
                </div>
            </div>

            <DataTable
                data={surveys}
                columns={columns}
                isLoading={loading}
            />
        </div>
    );
};

export default SurveyGlobalAnalytics;
